import { render } from "./qfooter.vue?vue&type=template&id=2edd9702"
import script from "./qfooter.vue?vue&type=script&lang=js"
export * from "./qfooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__